import { Row } from "antd";
import styled from "styled-components";

export const ActionButton = styled(Row)`
  border-radius: 12px;
  padding: 12px 20px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;

  .btn-text {
    color: rgba(24, 144, 255, 1) !important;
    transition: all 0.3s ease;
  }

  &:hover {
    background: rgba(24, 144, 255, 1);

    .btn-text {
      color: #ffffff !important;
    }
  }
`;